import { render } from "./Students.vue?vue&type=template&id=503ac25e&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"

import "./Students.vue?vue&type=style&index=0&id=503ac25e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503ac25e"]])

export default __exports__